import React, { ReactNode, useEffect, useState } from "react";

import { AuthenticationResult, InteractionType } from "@azure/msal-browser";
import { useMsalAuthentication } from "@azure/msal-react";

import { getAccessToken } from "./auth-fetch.ts";
import { msalInstance } from "./initialize-auth.ts";
import { loginRequest } from "./auth-config.ts";
import { UserProfileContext } from "../lib/user-context.ts";

export const AuthContextProvider = ({ children }: { children: ReactNode }) => {
  const [authState, setAuthState] = useState<AuthenticationResult | null>(null);

  const { result, error } = useMsalAuthentication(InteractionType.Redirect, loginRequest);

  useEffect(() => {
    if (result && !authState) {
      setAuthState(result);
    }

    // If we're running locally and we still don't have authState by this point it is due to
    // a StrictMode issue logged here: https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/5468
    // To work around this, we can fetch the authState oursevles
    if (!result && !authState && msalInstance.getActiveAccount()) {
      void getAccessToken().then(setAuthState);
    }
  }, [authState, result]);

  if (error) {
    return <code>There was an error logging in {error.errorMessage}</code>;
  }

  if (!authState) return null;
  const userInfo = {
    email: authState.account.username,
    displayName: authState.account.name,
    id: authState.uniqueId,
  };

  localStorage.setItem("user_id", userInfo.id);

  return <UserProfileContext.Provider value={{ user: userInfo }}>{children}</UserProfileContext.Provider>;
};
